import React from 'react'
import { reduxForm, Field } from 'redux-form'

import Card from '../Shared/Card'
import Button from '../Shared/Button'
import WrappedInput from '../Shared/Forms/WrappedInput'
import FormError from '../Shared/Forms/FormError'

const FORM_NAME = 'accountSettings'

const Form = function AccountForm({
  handleSubmit,
  submitting,
  pristine,
  error,
}) {
  return (
    <Card
      component="form"
      actions={
        <Button disabled={pristine} loading={submitting}>
          Save
        </Button>
      }
      onSubmit={handleSubmit}
    >
      <Field component={WrappedInput} name="name" label="Name" />
      <Field component={WrappedInput} name="email" label="Email" />
      <Field
        component={WrappedInput}
        name="oldPassword"
        label="Old Password"
        type="password"
      />
      <Field
        component={WrappedInput}
        name="password"
        label="Password"
        type="password"
      />
      {error && <FormError>{error}</FormError>}
    </Card>
  )
}

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(Form)
